import script from "./HeatMap.vue?vue&type=script&setup=true&lang=js"
export * from "./HeatMap.vue?vue&type=script&setup=true&lang=js"

import "./HeatMap.vue?vue&type=style&index=0&id=b3a5bd94&lang=css"

const __exports__ = script;

export default __exports__